import axios from "axios";
import {c2cUnitedUrl, c2cUrl, pulpalServices} from "../http";

export default class C2CService {
    static async amountTransfer(transferOptions: any) {
        try {
            return await axios.post(`${c2cUrl}/register`, {
                ...transferOptions, amount: transferOptions.amount * 100
            })
        }
        catch (err) {
            console.log('err')
        }
    }

    static async c2cTransfer(transferOptions: any) {
        try {
            return await axios.post(`${c2cUnitedUrl}/azericard/api/p2p`, {
                ...transferOptions
            })
        }
        catch (err) {
            console.log('err')
        }
    }

    static async c2cTransferRegister(transferOptions: any) {
        try {
            return await axios.post(`${c2cUnitedUrl}/payment-service/api/c2c/register`, {
                ...transferOptions
            })
        }
        catch (err: any) {
            console.log('err')
            // A 4xx carries the backend ApiError ({code, message}) — e.g. the per-sender daily /
            // monthly limit — so return the response and let the page decide what to show.
            return err?.response
        }
    }

    static async c2cReceiptTransfer(id: any) {
        try {
            return axios.get(`${c2cUnitedUrl}/payment-service/api/external/external/p2p/${id}`)
        }
        catch (err) {
            console.log('err')
        }
    }

    // PSP (Millikart) C2C receipt: paymentAttempt comes back from the payment redirect
    // (?transaction=... / ?ref=...). Returns status/amount/surcharge/totalAmount/cards/rrn.
    static async c2cReceipt(paymentAttempt: string) {
        try {
            return axios.get(`${c2cUnitedUrl}/payment-service/api/c2c/receipt`, {params: {paymentAttempt}})
        }
        catch (err) {
            console.log('err')
        }
    }

    static async getPurposes(language: string) {
        try {
            return axios.get(`${c2cUnitedUrl}/payment-service/api/c2c/purposes`, {params: {language}})
        }
        catch (err) {
            console.log('err')
        }
    }
}
